import { SelectOptionProxy } from "element-plus"

export const StorageKeysEnum = {
  TOKEN: "token",
  USER_INFO: "userInfo"
} as const

export const ResponseCodeEnum = {
  // 成功
  SUCCESS: 0,
  
  // 密码错误
  PASSWORD_ERROR: 1,
  
  // token 过期
  TOKEN_INVALID: 5001,
  
  // 快手未授权
  UNAUTHORIZED: 1521
} as const

export const PlatformEnum = {
  /**
   * 抖音
   */
  TIK_TOK: "douyin",
  
  /**
   * 快手
   */
  KWAI: "kuaishou"
} as const

export const CompanyEnum = {
  Type: {
    /**
     * 代理公司
     */
    AGENCY: 1,
    
    /**
     * 独立公司
     */
    INDEPENDENT: 2
  },
  Status: {
    /**
     * 启用
     */
    ENABLED: 1,
    
    /**
     * 禁用
     */
    DISABLED: 0
  }
} as const

type Values<T extends object> = T[keyof T];

export type CompanyTypeEnumType = Values<typeof CompanyEnum.Type>;

export type CompanyStatusEnumType = Values<typeof CompanyEnum.Status>;

export const OrganizationEnum = {
  Type: {
    DEPARTMENT: "dept",
    GROUP: "group"
  },
  DepartmentType: {
    MERCHANTS: 1,
    CHANNEL: 2
  }
} as const

export type OrganizationTypeEnum = Values<typeof OrganizationEnum.Type>

export type OrganizationDepartmentTypeEnum = Values<typeof OrganizationEnum.DepartmentType>

export const AccountTypeEnum = {
  ALL: undefined,
  LEADER: 1,
  CHANNEL: 2
} as const

export type AccountTypeTypeEnum = Values<typeof AccountTypeEnum>;

export const organizationTypes: Partial<SelectOptionProxy>[] = [
  {
    value: OrganizationEnum.Type.DEPARTMENT,
    label: "部门"
  },
  {
    value: OrganizationEnum.Type.GROUP,
    label: "小组"
  }
]

export const departmentTypes: Partial<SelectOptionProxy>[] = [
  {
    value: OrganizationEnum.DepartmentType.CHANNEL,
    label: "渠道"
  },
  {
    value: OrganizationEnum.DepartmentType.MERCHANTS,
    label: "招商"
  }
]

export const accountTypes: Partial<SelectOptionProxy>[] = [
  {
    label: "全部",
    value: AccountTypeEnum.ALL
  },
  {
    label: "团长",
    value: AccountTypeEnum.LEADER
  },
  {
    label: "渠道",
    value: AccountTypeEnum.CHANNEL
  }
]

export const workStatusEnum = {
  ALL: undefined,
  IN_SERVICE: 1,
  OUT_OF_SERVICE: 2
} as const

export type WorkStatusEnum = Values<typeof workStatusEnum>;

export const UserConstants = {
  DEFAULT_GENDER: 0
} as const

export const GroupRoles = {
  LEADER: 1,
  COMMON: 0
} as const

export interface IPlatformType {
  CODE_TO_TEXT: Record<number, string>;
  TEXT_TO_CODE: Record<string, number>;
}

export const PLATFORM_TYPE: IPlatformType = {
  CODE_TO_TEXT: {
    1: "douyin",
    2: "kuaishou"
  },
  TEXT_TO_CODE: {
    douyin: 1,
    kuaishou: 2
  }
}
